<template>
  <div>
    <ProfileBanner />
    <div class="container">
      <div class="row">
        <div
          class="col col-xl-9 order-xl-2 col-lg-9 order-lg-2 col-md-12 order-md-1 col-sm-12 col-12"
        >
          <div class="ui-block" ref="updateInfo">
            <div class="ui-block-title">
              <h6 class="title" style="color: #fff">Personal Information</h6>
            </div>
            <div class="ui-block-content">
              <!-- Personal Information Form  -->
              <response-message :data="errorData" />
              <form id="info_change_form" method="post" v-on:submit.prevent="updateInfo()">
                <div class="row">
                  <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                    <div :class=" formModel.firstname !== null ? 'form-group label-floating' : 'form-group label-floating is-empty' ">
                      <label class="control-label"> {{ getUserDetails.user_type === '1' ? 'First Name' : 'Business Name' }} </label>
                      <input class="form-control" v-model="formModel.firstname" id="firstname" placeholder type="text" value="John" />
                    </div>

                    <div :class=" formModel.email !== null ? 'form-group label-floating' : 'form-group label-floating is-empty' ">
                      <label class="control-label">Your Email</label>
                      <input
                        class="form-control"
                        placeholder
                        type="email"
                        v-model="formModel.email"
                        id="email"
                        value="support@matchdaydeals.com"
                      />
                    </div>
                    <div :class=" formModel.club !== null && getUserDetails.user_type === '1' || formModel.business_address !== null ? 'form-group label-floating' : 'form-group label-floating is-empty' ">
                      <div class="dropdown">
                        <label class="control-label">Fan Club Name</label>
                        <input ref="dropdowninput" v-model.trim="inputValue" v-if="Object.keys(selectedItem).length === 0" class="form-control dropdown-input" type="text" placeholder="Search Club" />
                        <div v-else @click="resetItem" class="dropdown-selected">
                          <img :src="selectedItem.team_badge" class="dropdown-item-flag" />
                          {{ selectedItem.team_name }}
                        </div>
                        <div v-show="inputValue && itemList.length > 0" class="dropdown-list">
                          <div v-for="item in itemList" :key="item.name" v-show="itemVisible(item)" @click="selectTeam(item)" class="dropdown-item">
                            <img :src="item.team_badge" class="dropdown-item-flag"/>
                            {{ item.team_name }}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div class="col col-lg-6 col-md-6 col-sm-12 col-12">

                    <div :class=" userDetails.lastname !== null && this.formModel.business_city !== null ? 'form-group label-floating' : 'form-group label-floating is-empty' ">
                      <label class="control-label">{{ getUserDetails.user_type === '1' ? 'Last Name' : 'Business City' }}</label>
                      <input class="form-control" v-model="formModel.lastname" id="lastname" placeholder type="text" value="Doe" />
                    </div>

                    <div :class=" userDetails.username !== null ? 'form-group label-floating' : 'form-group label-floating is-empty' ">
                      <label class="control-label">Your Username</label>
                      <input
                              class="form-control"
                              placeholder
                              type="text"
                              v-model="formModel.username"
                              id="username"
                              value="johndoe"
                              disabled
                      />
                    </div>

                    <div :class=" userDetails.username !== null ? 'form-group label-floating' : 'form-group label-floating is-empty' ">
                      <label class="control-label">Your Phone Number</label>
                      <input
                              class="form-control"
                              placeholder
                              type="number"
                              v-model="formModel.phone"
                              id="phone"
                              value="+234()"
                      />
                    </div>

                  </div>

                  <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                    <button type="submit" class="btn bg-mdd btn-lg full-width" >Update Profile</button>
                  </div>
                </div>
              </form>

              <!-- ... end Personal Information Form  -->
            </div>
          </div>
        </div>

        <settingsBar :data="SettingsData" />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import ProfileBanner from "../../components/Profile/ProfileBanner";
import settingsBar from "@/components/Profile/SettingsRightBar";
import Footer from "../../components/Home/Footer";
import {mapState} from "vuex";
import jquery from "jquery";

// let $ = jquery;

var pageData = {
  projectName: "",
  userData: {},
  id: null,
  avatar: "",
  signedIn: false,
  SettingsData: {
      active: 'Account',
  },
  formModel: {
    email: '',
    firstname: '',
    lastname: '',
    phone: '',
    club: '',
    username: '',
  },
  inputValue: '',
  itemList: [],
  selectedItem: {},
  errorData: {},
  userDetails: {},
};

export default {
  name: "AccountInfo",
  data() {
    return pageData;
  },
  components: { settingsBar, Footer, ProfileBanner },
  computed: mapState({
    getAvatar: state => state.user.avatar,
    getUsername: state=> state.user.username,
    getUserDetails: state => state.user,
  }),
  methods: {
    selectTeam(team) {
      const item = {
        team_name: team.team_name,
        team_id: team.team_id,
        team_badge: team.team_badge,
      }
      this.selectedItem = item
      this.formModel.club = team.team_id;
      this.inputValue = ''
    },
    resetItem () {
      this.selectedItem = {}
      this.$nextTick( () => this.$refs.dropdowninput.focus() )
    },
    itemVisible (item) {
      let currentName = item.team_name.toLowerCase()
      let currentInput = this.inputValue.toLowerCase()
      return currentName.includes(currentInput)
    },
    getTeamsData() {
      this.itemList = {}
      this.axios.get('/teams/all')
      .then((res) => {
        const data = res.data.data.teams
        this.itemList = data
        // console.log(data)
      })
    },
    showLoading() {
			let loader = this.$loader(this, this.$refs.updateInfo, {loaderType: "spinner"});
			return loader;
		},
    // validate form fields
    validateForm() {
      if (
              this.formModel.email === "" &&
              this.formModel.firstname === "" &&
              this.formModel.lastname === "" &&
              this.formModel.club === "" &&
              this.formModel.username === ""
      ) {
        $("#info_change_form .label-floating").addClass('has-error');
        $("#info_change_form input").addClass('form-control-danger');
        this.errorData = {
          message: "Sorry all fields are required",
          isError: true,
        };
        return false;
      }else if (
              !this.$validate("nametext", this.formModel.firstname)
      ) {
        $("#info_change_form input#firstname").parent(".label-floating").addClass('has-error')
        $("#info_change_form input#firstname").addClass('form-control-danger')
        this.errorData = {
          message: "Sorry your Firstname Characters are wrong",
          isError: true,
        }
        return false;
      }else if (
              !this.$validate("nametext", this.formModel.lastname)
      ) {
        $("#info_change_form #lastname").parent(".label-floating").addClass('has-error')
        $("#info_change_form input#lastname").addClass('form-control-danger')
        this.errorData = {
          message: "Sorry your Lastname Characters are wrong",
          isError: true,
        }
        return false;
      }else if (
              !this.$validate("email", this.formModel.email)
      ) {
        $("#info_change_form #email").parent(".label-floating").addClass('has-error')
        $("#info_change_form input#email").addClass('form-control-danger')
        this.errorData = {
          message: "Sorry your Email Characters are wrong",
          isError: true,
        }
        return false;
      }

      else if (
              !this.$validate("longtext", this.formModel.username)
      ) {
        $("#info_change_form #username").parent(".label-floating").addClass('has-error')
        $("#info_change_form input#username").addClass('form-control-danger')
        this.errorData = {
          message: "Sorry your Username Characters are wrong",
          isError: true,
        }
        return false;
      }

      else if ( this.formModel.phone !== '' && !this.$validate("phone", this.formModel.phone)) {
        $("#info_change_form #phone").parent(".label-floating").addClass('has-error')
        $("#info_change_form input#phone").addClass('form-control-danger')
        this.errorData = {
          message: "Sorry give a valid phone number",
          isError: true,
        }
        return false;
      }

      else {
        $("#info_change_form .label-floating").removeClass('has-error');
        $("#info_change_form input").removeClass('form-control-danger');
        return true;
      }
    },
    // submit the password change form
    updateInfo() {
      // validate the form first
      if(this.validateForm()) {
        let loader = this.showLoading();
        const requestPayload = {
          firstname: this.formModel.firstname,
          lastname: this.formModel.lastname,
          email: this.formModel.email,
          club: this.formModel.club,
          phone: this.formModel.phone,
        };

        this.axios.post('/profile/update', requestPayload)
          .then(() => {
            loader.hide();
            this.errorData = {
              message: 'Profile updated successfully',
              isError: "success",
            };
            this.fetchUserDetails();
          })
          .catch(error => {
            // console.log(error)
            loader.hide();
            this.errorData = {
              message: error.response
                      ? "Please check your Profile Details"
                      : "Sorry an error occurred, check your internet",
              isError: true,
            };
          })

      }
    },
    // fetch the users details
    fetchUserDetails() {
      var loader = this.showLoading();
      this.axios.get('/user/details')
      .then(response => {
        loader.hide();
        // console.log(response.data.data)
        this.userDetails = response.data.data;
        this.formModel.email = this.userDetails.email;
        this.formModel.firstname = this.userDetails.firstname;
        this.formModel.lastname = this.userDetails.lastname;
        this.formModel.username = this.userDetails.username;
        if (this.userDetails.team_details[0]) {
          this.selectedItem = this.userDetails.team_details[0]
        }
        this.formModel.phone = this.userDetails.phone;
        window.eventBus.$emit("loadUserData", true);
      })
      .catch(error => {
        this.errorData = {
          message: error.response
            ? "An error from our end"
            : "Sorry an error occured, check your internet",
          isError: true,
        };
        loader.hide();
      })
    },
    checkUserData(userData) {
      if (userData !== "" || userData !== "undefined") {
        this.userData = JSON.parse(userData);
        this.signedIn = true;
      }
    },
  },
  mounted() {
    var userData = localStorage.fansData;
    // load the user details
    this.fetchUserDetails();
    if (userData) {
      this.checkUserData(userData);
    }
    this.getTeamsData()
  },
};
</script>

<style>
  .dropdown{
    position: relative;
    width: 100%;
    margin: 0 auto;
  }
  .dropdown-selected{
    width: 100%;
    border: 1px solid transparent;
    background: #edf2f7;
    line-height: 1.5em;
    outline: none;
    padding: 24px 16px 10px;
    border-radius: 3px;
  }
  .dropdown-input:focus, .dropdown-selected:hover{
    background: #fff;
    border-color: #e2e8f0;
  }
  .dropdown-input::placeholder{
    opacity: 0.7;
  }
  .dropdown-selected{
    font-weight: bold;
    cursor: pointer;
  }
  .dropdown-list{
    position: absolute;
    width: 100%;
    max-height: 500px;
    margin-top: 4px;
    overflow-y: auto;
    background: #ffffff;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    z-index: 2;
  }
  .dropdown-item{
    display: flex;
    width: 100%;
    padding: 11px 16px;
    cursor: pointer;
  }
  .dropdown-item:hover{
    background: #edf2f7;
  }
  .dropdown-item-flag{
    max-width: 24px;
    max-height: 18px;
    margin: auto 12px auto 0px;
    position: relative;
    top: 4px;
  }
  /*.ui-block {*/
  /*  border:none !important;*/
  /*}*/
</style>
